.sessionDuration {
  width: 135px;

  input {
    width: 86px;
    flex: unset;
  }
}
